"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFunction = void 0;
/**
 * Returns true if the element has the type function
 * @public
 *
 * @param arg - A generic argument to check
 *
 * @returns A boolean indicating whether the arg is a Function or not.
 *
 * @example
 * ```ts
 * const result = isFunction(undefined);
 * console.log(result);
 * // -> false
 * ```
 **/
function isFunction(arg) {
    return 'function' === typeof arg;
}
exports.isFunction = isFunction;
//# sourceMappingURL=is-function.js.map